import * as tslib_1 from "tslib";
import React from 'react';
import styled from 'styled-components';
var CalendarDayGridBox = styled.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n  padding: 4px 8px 8px 8px;\n  width: 280px;\n  height: 236px;\n  justify-content: left;\n  margin-top: ", ";\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  padding: 4px 8px 8px 8px;\n  width: 280px;\n  height: 236px;\n  justify-content: left;\n  margin-top: ", ";\n"])), function (props) { return (props.weekDay <= 2 ? '18px' : '0px'); });
// tslint:disable-next-line:no-any
export default function CalendarDayGridLayout(props) {
    // tslint:disable-next-line:no-any
    return (React.createElement(CalendarDayGridBox, { weekDay: props.weekDay }, props.children));
}
var templateObject_1;
//# sourceMappingURL=CalendarDayGridLayout.js.map